module.exports = __webpack_public_path__ + "asset/image-no-team-eac2cb6788041a58.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/scene/authorized/scene/calendar/image/no-team.svg
// module id = 3Mt+
// module chunks = 0